import { useState } from 'react'
import BusinessService from './BusinessService'
import EditServiceModal from 'pages/Modals/EditServiceModal'

import {
  Container,
  SubTitle,
  InfoText,
  LabelRow
} from './styles'

export default function BusinessServiceList ({
  services = [],
  weekdays = [],
  businessProducts = [],
  serviceCategories = [],
  professionalID,
  onEdit: handleEdit,
  onDelete: handleDelete
}) {
  const [serviceData, setServiceData] = useState (null)
  const [showEditServiceModal, setShowEditServiceModal] = useState (false)
  
  const editService = service => {
    setServiceData (service)
    toggleEditServiceModal ()
  }

  const toggleEditServiceModal = () => setShowEditServiceModal (!showEditServiceModal) 

  if (services.length === 0) return (
    <Container>
      <InfoText>Você ainda não possui serviços cadastrados</InfoText>
    </Container>
  )

  return (
    <Container>
      <LabelRow>
        <SubTitle>Nome</SubTitle>
        <SubTitle>Duração</SubTitle>
        <SubTitle>Tolerância</SubTitle>
        <SubTitle>Comissão</SubTitle>
        <SubTitle>Preço</SubTitle>
        <SubTitle>Ações</SubTitle>
      </LabelRow>
      {services.map ((service, index) => (
        <BusinessService
          key={index}
          data={service}
          weekdays={weekdays}
          professionalID={professionalID}
          onEdit={editService}
          onEditPromotion={handleEdit}
          onDelete={handleDelete}
        />
      ))}
      {!!serviceData && (
        <EditServiceModal
          visible={showEditServiceModal}
          data={serviceData}
          weekdays={weekdays}
          businessProducts={businessProducts}
          serviceCategories={serviceCategories}
          professionalID={professionalID}
          onClose={toggleEditServiceModal}
          onConfirm={handleEdit}
        />
      )}
    </Container>
  )
}
